import styled from "styled-components";
import { NavLink as Link } from "react-router-dom";
import { colors, easing, fonts, layout, media } from "../../../theme";

export const FooterContainer = styled.footer`
  position: relative;
  background-color: ${colors.secondary};
  color: rgba(255, 255, 234, 0.72);
  padding: clamp(3.5rem, 7vw, 5rem) ${layout.gutter} 0;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
      90deg,
      ${colors.primary},
      ${colors.buttonHover},
      ${colors.primary}
    );
  }
`;

export const FooterInner = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1.3fr;
  gap: 3rem;
  max-width: ${layout.maxWidth};
  margin: 0 auto;

  ${media.tablet} {
    grid-template-columns: 1fr 1fr;
  }

  ${media.mobile} {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
`;

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;

  ${media.tablet} {
    grid-column: 1 / -1;
  }
`;

export const FooterLogo = styled.img`
  width: 11rem;
  height: auto;
`;

export const Motto = styled.p`
  max-width: 22rem;
  font-family: ${fonts.heading};
  font-style: italic;
  font-size: 1.1rem;
  color: rgba(255, 255, 234, 0.85);
`;

export const SocialLink = styled.a`
  display: grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 1px solid rgba(255, 255, 234, 0.2);
  border-radius: 50%;
  color: ${colors.primary};
  font-size: 1.15rem;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-color 0.3s ease, transform 0.4s ${easing.out};

  &:hover {
    background-color: ${colors.primary};
    border-color: ${colors.primary};
    color: ${colors.secondary};
    transform: translateY(-3px);
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

export const ColumnTitle = styled.h3`
  margin-bottom: 0.4rem;
  font-family: ${fonts.body};
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${colors.primary};
`;

export const FooterLinks = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const FooterLink = styled(Link)`
  color: rgba(255, 255, 234, 0.78);
  text-decoration: none;
  transition: color 0.3s ease, transform 0.4s ${easing.out};

  &:hover,
  &.active {
    color: ${colors.primary};
  }

  &:hover {
    transform: translateX(4px);
  }
`;

const contactRow = `
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  line-height: 1.5;

  svg {
    flex-shrink: 0;
    margin-top: 0.2rem;
    color: ${colors.primary};
  }
`;

export const ContactItem = styled.div`
  ${contactRow}
`;

export const ContactLink = styled.a`
  ${contactRow}
  color: rgba(255, 255, 234, 0.78);
  text-decoration: none;
  overflow-wrap: anywhere;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.primary};
  }
`;

export const BottomBar = styled.div`
  max-width: ${layout.maxWidth};
  margin: clamp(3rem, 6vw, 4rem) auto 0;
  padding: 1.5rem 0 calc(1.5rem + env(safe-area-inset-bottom));
  border-top: 1px solid rgba(255, 255, 234, 0.1);
  font-size: 0.85rem;
  color: rgba(255, 255, 234, 0.5);
`;
